/* eslint-disable no-nested-ternary */
import {
  AppstoreOutlined,
  DeleteFilled,
  EditOutlined,
  IdcardOutlined,
  LinkOutlined,
  LoadingOutlined,
  MailOutlined,
  PhoneOutlined,
  TagOutlined,
  TeamOutlined,
  UserOutlined,
  WhatsAppOutlined,
} from '@ant-design/icons'
import {
  Card,
  Col,
  Row,
  Avatar,
  Typography,
  Space,
  Button,
  Flex,
  Tooltip,
  Popconfirm,
} from 'antd'
import React from 'react'

import { useParams, useHistory } from 'react-router-dom'

import { useClients } from '~/hooks/Clients/useClients'

import { Container, LoadingIndicator } from './styles'
import AdditionalPhones from '../AditionalPhones'
import TalkToContact from '../TalkToContact'
import { useListTask } from '~/hooks/Tasks/useListTasks'
import { createLetterAvatar } from '~/utils/letter'
import { translate } from '~/utils/locale'
import { useCompanies } from '~/hooks/Companies/useCompanies'
import { encode } from 'base-64'
import ShareButton from '~/components/DataManipulation/Misc/ShareButton'
import { EditButton } from '~/components/DefaultLayout/Buttons/buttonStyle'

const DetailsTab: React.FC = () => {
  const { customerId } = useParams<{ customerId: string }>()

  const { companiesData, selectedCompany } = useCompanies()

  const { clients, isLoading, setIsEdit, deleteClient } = useClients()
  const { handleUpdateFilters } = useListTask()

  const { Title, Text } = Typography

  const user = companiesData?.[0].collaborator.contact.name

  const history = useHistory()

  if (isLoading || !clients) {
    return (
      <LoadingIndicator>
        <LoadingOutlined style={{ fontSize: 64, margin: 'auto' }} spin />
      </LoadingIndicator>
    )
  }

  const nameEncoded = encode(
    clients?.contact.name ? clients?.contact.name : 'null',
  )
  const emailEncoded = encode(
    clients?.contact.email ? clients?.contact.email : 'null',
  )
  const phoneEncoded = encode(
    clients?.contact.phone ? clients?.contact.phone : 'null',
  )
  const companyNameEncoded = encode(
    clients?.company.name ? clients.company.name : 'null',
  )

  function handleFilterTaskClient() {
    const data = {
      customers_id: customerId,
    }

    handleUpdateFilters(data)
    history.push('/agenda')
  }

  return (
    <Container>
      <Card
        bordered={false}
        title={
          <Title level={5} style={{ marginBottom: 0, fontSize: 18 }}>
            {translate('ClientsDetailsTab.cardGeneralInfoTitle')}
          </Title>
        }
        extra={
          <Space>
            <ShareButton
              type="filled"
              link={`https://app.gstor.com.br/novoTicket/${selectedCompany}/client/${nameEncoded}/${emailEncoded}/${phoneEncoded}/${companyNameEncoded}`}
              modalText={translate('ClientsDetailsTab.shareModalText')}
            />
            <Button
              type="primary"
              onClick={handleFilterTaskClient}
              icon={<LinkOutlined />}
            >
              {translate('ClientsDetailsTab.seeTasksButton')}
            </Button>
            <EditButton
              type="primary"
              icon={<EditOutlined />}
              onClick={() => setIsEdit(true)}
            >
              {translate('ClientsDetailsTab.editButton')}
            </EditButton>
            <Tooltip title="Deletar">
              <Popconfirm
                title="Deseja realmente excluir o cliente?"
                onConfirm={() => deleteClient()}
              >
                <Button type="primary" danger icon={<DeleteFilled />} />
              </Popconfirm>
            </Tooltip>
          </Space>
        }
        style={{
          display: 'inline-block',
          width: '100%',
        }}
      >
        <Flex gap={20}>
          <Avatar
            shape="square"
            size={140}
            style={{
              fontSize: 30,
              color: '#fff',
              background: 'linear-gradient(135deg, #3C8ACB 0%, #3969B7 100%)',
              borderRadius: 12,
            }}
          >
            {createLetterAvatar(`${clients.contact.name}`)}
          </Avatar>
          <Flex vertical gap={10}>
            <Flex gap={60}>
              <Flex gap={10} style={{ minWidth: 350 }}>
                <Avatar
                  shape="square"
                  icon={
                    <UserOutlined style={{ fontSize: 12, color: '#464545' }} />
                  }
                  size="small"
                  style={{ background: '#DADADA' }}
                />
                <div>
                  <Title level={5} style={{ marginBottom: 0 }}>
                    {translate('ClientsDetailsTab.nameLabel')}
                  </Title>
                  <Text>{clients.contact.name}</Text>
                </div>
              </Flex>

              <Flex gap={10} style={{ minWidth: 350 }}>
                <Avatar
                  shape="square"
                  icon={
                    <MailOutlined style={{ fontSize: 12, color: '#464545' }} />
                  }
                  size="small"
                  style={{ background: '#DADADA' }}
                />
                <div>
                  <Title level={5} style={{ marginBottom: 0 }}>
                    {translate('ClientsDetailsTab.emailLabel')}
                  </Title>
                  {clients?.contact?.email === null ? (
                    <Text>{translate('ClientsDetailsTab.createdNull')}</Text>
                  ) : (
                    <Text>{clients?.contact?.email}</Text>
                  )}
                </div>
              </Flex>
            </Flex>

            <Flex gap={60}>
              <Flex gap={10} style={{ minWidth: 350 }}>
                <Avatar
                  shape="square"
                  icon={
                    <UserOutlined style={{ fontSize: 12, color: '#464545' }} />
                  }
                  size="small"
                  style={{ background: '#DADADA' }}
                />
                <div>
                  <Title level={5} style={{ marginBottom: 0 }}>
                    {translate('ClientsDetailsTab.personTypeLabel')}
                  </Title>
                  {clients.contact.person_type === 'physicalPerson' ? (
                    <div>
                      <Text>
                        {translate('ClientsDetailsTab.physicalPersonType')}
                      </Text>
                    </div>
                  ) : clients.contact.person_type === 'legalPerson' ? (
                    <Text>
                      {translate('ClientsDetailsTab.juridicPersonType')}
                    </Text>
                  ) : (
                    <Text>{translate('ClientsDetailsTab.foreignType')}</Text>
                  )}
                </div>
              </Flex>

              <Flex gap={10} style={{ minWidth: 350 }}>
                <Avatar
                  shape="square"
                  icon={
                    <IdcardOutlined
                      style={{ fontSize: 12, color: '#464545' }}
                    />
                  }
                  size="small"
                  style={{ background: '#DADADA' }}
                />
                <div>
                  <Title level={5} style={{ marginBottom: 0 }}>
                    {clients.contact.person_type === 'foreign'
                      ? translate('ClientsDetailsTab.passportLabel')
                      : translate('ClientsDetailsTab.cpfLabel')}
                  </Title>
                  {clients?.contact.document === null ? (
                    <Text>{translate('ClientsDetailsTab.createdNull')}</Text>
                  ) : (
                    <Text>{clients.contact.formattedDocument}</Text>
                  )}
                </div>
              </Flex>
            </Flex>

            <Flex gap={60}>
              <Flex gap={10} style={{ minWidth: 350 }}>
                <Avatar
                  shape="square"
                  icon={
                    clients.contact.is_whatsapp ? (
                      <WhatsAppOutlined
                        style={{ fontSize: 12, color: '#464545' }}
                      />
                    ) : (
                      <PhoneOutlined
                        style={{ fontSize: 12, color: '#464545' }}
                      />
                    )
                  }
                  size="small"
                  style={{ background: '#DADADA' }}
                />
                <div>
                  {clients.contact.is_whatsapp ? (
                    <Title level={5} style={{ marginBottom: 0 }}>
                      {translate('ClientsDetailsTab.whatsappPhoneLabel')}
                    </Title>
                  ) : (
                    <Title level={5} style={{ marginBottom: 0 }}>
                      {translate('ClientsDetailsTab.phoneLabel')}
                    </Title>
                  )}

                  {clients.contact.phone !== null ? (
                    <Text>{clients.contact.formattedPhone}</Text>
                  ) : (
                    <Text>{translate('ClientsDetailsTab.phoneNullLabel')}</Text>
                  )}
                </div>
              </Flex>

              <Flex gap={10} style={{ minWidth: 350 }}>
                <Avatar
                  shape="square"
                  icon={
                    <PhoneOutlined style={{ fontSize: 12, color: '#464545' }} />
                  }
                  size="small"
                  style={{ background: '#DADADA' }}
                />
                <div>
                  <Title level={5} style={{ marginBottom: 0 }}>
                    {translate('ClientsDetailsTab.additionalPhonesLabel')}
                  </Title>
                  <AdditionalPhones />
                </div>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Card>

      <Card
        bordered={false}
        title={
          <Title level={5} style={{ marginBottom: 0, fontSize: 18 }}>
            {translate('ClientsDetailsTab.cardOtherInfoTitle')}
          </Title>
        }
        style={{
          display: 'inline-block',
          width: '100%',
          marginTop: 10,
        }}
      >
        <Row>
          <Col span={8}>
            <Flex gap={10}>
              <Avatar
                shape="square"
                icon={
                  <UserOutlined style={{ fontSize: 12, color: '#464545' }} />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  {translate('ClientsDetailsTab.createdLabel')}
                </Title>
                {user === undefined ? (
                  <Text>{translate('ClientsDetailsTab.createdNull')}</Text>
                ) : (
                  <Text>{user}</Text>
                )}
              </div>
            </Flex>
          </Col>

          <Col span={8}>
            <Flex gap={10}>
              <Avatar
                shape="square"
                icon={
                  <TagOutlined style={{ fontSize: 12, color: '#464545' }} />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  {translate('ClientsDetailsTab.corporateNameLabel')}
                </Title>
                {clients.corporate_name ? (
                  <Text>{clients.corporate_name}</Text>
                ) : (
                  <Text>Nenhuma informação disponível.</Text>
                )}
              </div>
            </Flex>
          </Col>

          <Col span={8}>
            <Flex gap={10}>
              <Avatar
                shape="square"
                icon={
                  <AppstoreOutlined
                    style={{ fontSize: 12, color: '#464545' }}
                  />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  {translate('ClientsDetailsTab.segmentLabel')}
                </Title>
                {clients.segment ? (
                  <Text>{clients.segment?.title}</Text>
                ) : (
                  <Text>Nenhuma informação disponível.</Text>
                )}
              </div>
            </Flex>
          </Col>
        </Row>

        <Row style={{ marginTop: 14 }}>
          <Col span={8}>
            <Flex gap={10}>
              <Avatar
                shape="square"
                icon={
                  <LinkOutlined style={{ fontSize: 12, color: '#464545' }} />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  {translate('ClientsDetailsTab.externalCodeLabel')}
                </Title>
                {clients.external_code ? (
                  <Text>{clients.external_code}</Text>
                ) : (
                  <Text>Nenhuma informação disponível.</Text>
                )}
              </div>
            </Flex>
          </Col>

          <Col span={8}>
            <Flex gap={10}>
              <Avatar
                shape="square"
                icon={
                  <TeamOutlined style={{ fontSize: 12, color: '#464545' }} />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  {translate('ClientsDetailsTab.talkToContactLabel')}
                </Title>
                <TalkToContact />
              </div>
            </Flex>
          </Col>

          <Col span={8}>
            <Flex gap={10}>
              <Avatar
                shape="square"
                icon={
                  <MailOutlined style={{ fontSize: 12, color: '#464545' }} />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  {translate('ClientsDetailsTab.responsibleLabel')}
                </Title>
                {clients?.collaborator?.contact?.name ? (
                  <Text>{clients?.collaborator?.contact?.name}</Text>
                ) : (
                  'Nenhuma informação disponível.'
                )}
              </div>
            </Flex>
          </Col>
        </Row>

        <Row style={{ marginTop: 14 }}>
          <Flex gap={10}>
            <Avatar
              shape="square"
              icon={<EditOutlined style={{ fontSize: 12, color: '#464545' }} />}
              size="small"
              style={{ background: '#DADADA' }}
            />
            <div>
              <Title level={5} style={{ marginBottom: 0 }}>
                {translate('ClientsDetailsTab.observationLabel')}
              </Title>
              {clients.notes ? (
                <Text>{clients.notes}</Text>
              ) : (
                <div className="notes">
                  <Text>Nenhuma informação disponível.</Text>
                </div>
              )}
            </div>
          </Flex>
        </Row>
      </Card>
    </Container>
  )
}

export default DetailsTab
